export default "__VITE_ASSET__K7w1GM35__"